export enum TriggerConditionType {
  Field = 'Field',
  Metadata = 'Metadata',
  AmountOfWork = 'AmountOfWork'
}
